import { render, staticRenderFns } from "./ManagersCommission.vue?vue&type=template&id=6d0c39ea&scoped=true&"
import script from "./ManagersCommission.vue?vue&type=script&lang=js&"
export * from "./ManagersCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c39ea",
  null
  
)

export default component.exports